/**
 * Created by Ning Jiang on 2024-01-23.
 */

import {DeadwoodRip} from "../../DeadwoodRip";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TimelineLite} from "gsap";

export interface IShootableItem {
    kill():TimelineLite;
}

export interface IShootableItemConfig {
    name:string;
    target?:PIXI.Container;
    holeScale?:number;
    holeGetter?:() => PIXI.Sprite;
    splashGetter?:() => PIXI.Sprite,
    sparkGetter?:() => TimelineSprite,
    view0:PIXI.DisplayObject;
    view1?:PIXI.DisplayObject;
    soundPlayer?:(stereoIndex:number) => TimelineLite;
    killabled?:boolean;
}

export class ShootableItem extends PIXI.Container implements IShootableItem {

    public reelId:number;
    protected _itemName:string;
    private _holeScale:number;
    private _view0:PIXI.DisplayObject;
    private _view1:PIXI.DisplayObject;
    private _soundPlayer:(stereoIndex:number) => TimelineLite;
    private _splashGetter:() => PIXI.Sprite;
    private _holeGetter:() => PIXI.Sprite;
    private _sparkGetter:() => TimelineSprite;
    protected _shootContainer:PIXI.Container;
    protected _killable:boolean;
    protected _isKilled:boolean = false;

    constructor(config:IShootableItemConfig) {
        super();

        this._itemName = config.name;
        this._holeScale = config.holeScale ? config.holeScale : 1;
        this._killable = config.killabled ? config.killabled : false;
        this._view0 = config.view0;
        this.addChild(config.view0);
        if(config.view1) {
            this._view1 = config.view1;
        }
        if(config.soundPlayer) {
            this._soundPlayer = config.soundPlayer;
        }
        if(config.target) {
            this._shootContainer = config.target;
        }
        if(config.splashGetter) {
            this._splashGetter = config.splashGetter;
        }
        if(config.holeGetter) {
            this._holeGetter = config.holeGetter;
        }
        if(config.sparkGetter) {
            this._sparkGetter = config.sparkGetter;
        }
        DeadwoodRip.shootingScreen.shootingItems.push(this);

        this.on('pointertap', (e:PIXI.InteractionEvent) => this.onShot(e));
        this.setEnabled(false);
    }

    public onRemove():void {
        ArrayHelper.removeFirstMatchElement(DeadwoodRip.shootingScreen.shootingItems, this);
    }

    private onShot(e:PIXI.InteractionEvent):void {
        e.stopPropagation();
        const localPosition = e.data.getLocalPosition(this);
        const ePosition = e.data.global.clone();
        Logger.logDev(`Shot item ${this._itemName} at local position [${localPosition.x}, ${localPosition.y}]`);
        this.shotAt([localPosition, ePosition]);
    }

    public shotAt(positions:PIXI.Point[], isFeatureShoot:boolean = false, alwaysReset:boolean = true, animate:boolean = true,
                  splashGetter?:() => PIXI.Sprite, holeGetter?:() => PIXI.Sprite, sparkGetter?:() => TimelineSprite):TimelineLite {
        const tl = new TimelineLite();
        if(DeadwoodRip.shootingScreen.tryShot({
            timeline : tl,
            target : this._shootContainer != null ? this._shootContainer : this,
            positions : positions,
            splashGetter : splashGetter ? splashGetter : this._splashGetter,
            holeGetter : holeGetter ? holeGetter : this._holeGetter,
            sparkGetter : sparkGetter ? sparkGetter : this._sparkGetter,
            soundPlayer : animate ? this._soundPlayer : undefined,
            isFeatureShoot : isFeatureShoot,
            playScreenEffects : true,
            alwaysReset : alwaysReset,
            killed : this._isKilled,
            reelId : this.reelId
        })) {
            tl.add(this.playOnShot());
            if(this._killable) {
                tl.add(this.kill(), 0);
            }
        }
        return tl;
    }

    public static getDefaultWoodHole(holeScale:number):PIXI.Sprite {
        const hole:PIXI.Sprite = new PIXI.Sprite(DeadwoodRip.assetLoader.getTextures("shot/holes/woodshot_")[Math.floor(Math.random() * 6)]);
        hole.scale.set(holeScale);
        hole.anchor.set(0.5);
        hole.rotation = Math.random() * 2 * Math.PI;

        return hole;
    }

    public static getDefaultWoodSpark(sparkScale:number):TimelineSprite {
        const smallSmoke = new TimelineSprite(DeadwoodRip.assetLoader.getTextures("shot/SparkSmoke/SparkSmoke_"));
        smallSmoke.blendMode = PIXI.BLEND_MODES.ADD;
        smallSmoke.anchor.set(0.5);
        smallSmoke.scale.set(sparkScale);
        return smallSmoke;
    }

    public playOnShot():TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I play on shot!`);
        });
        return tl;
    }

    public kill():TimelineLite {
        const tl = new TimelineLite();
        if(!this._isKilled) {
            tl.add(() => {
                Logger.logDev(`I am ${this._itemName}, I am killed!`);
            });
            tl.add(this.playKill());
            this._isKilled = true;
            return tl;
        }
        tl.add(() => {
            Logger.logDev(`I am ${this._itemName}, I am already killed!`);
        });
        return tl;
    }

    protected playKill():TimelineLite {
        return new TimelineLite();
        // if(this._view1) {
        //     this.addChild(this._view1);
        //     if(this._view0.parent) {
        //         this.removeChild(this._view0);
        //     }
        // }
    }

    public setEnabled(enabled:boolean):void {
        this.buttonMode = enabled;
        this.interactive = enabled;
        this.interactiveChildren = enabled;
    }

    public reset():void {
        this.addChild(this._view0);
        if(this._view1 && this._view1.parent) {
            this.removeChild(this._view1);
        }
        this._isKilled = false;
    }
}